import { GraphUserBaseData } from './models/services/user.model';

export const GRAPH_API_BASE = 'https://graph.microsoft.com/v1.0';
export const GRAPH_API_BETA_BASE = 'https://graph.microsoft.com/beta';
export const DEEP_LINK_BASE = 'https://teams.microsoft.com/l';

export const ASSETS = { bNearPhoto: 'assets/img/icons/logos/bnear-letters.svg' };

export const SUPPORT_USER_ID = '4f3d1f21-8152-42b6-8af0-57bcc074ca74';
export const SUPPORT_USER_PRINCIPAL_NAME = 'support@bnear.eu';
export const SUPPORT_USER_DATA: GraphUserBaseData = {
  displayName: 'Bruno von bNear',
  userPrincipalName: SUPPORT_USER_PRINCIPAL_NAME,
  emailAddress: SUPPORT_USER_PRINCIPAL_NAME,
  firstName: 'Bruno',
  lastName: 'von bNear',
  jobTitle: 'Office-Dog',
};
export const SUPPORT_USER_AVATAR =
  'data:image/png;base64,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';

export const AUTHENTICATION_REQUIRES_CONSENT = 'resource requires consent';
export const MOBILE_MEDIA_QUERY = '(max-width: 600px)';

export const TRANSLATION_KEYS = {
  meeting: {
    runningMeeting: 'meeting.runningMeeting',
    breakoutMeetingSubject: 'meeting.breakoutMeetingSubject',
    impromptuMeetingSubject: 'meeting.impromptuMeetingSubject',
  },
  chat: {
    you: 'chat.you',
    today: 'chat.today',
    yesterday: 'chat.yesterday',
    unknown: 'chat.unknown',
    groupChat: 'chat.groupChat',
    message: {
      failedImageLink: 'chat.message.failedImageLink',
    },
    systemEvent: {
      callDuration: {
        hours: 'chat.systemEvent.callDuration.hours',
        minutes: 'chat.systemEvent.callDuration.minutes',
        seconds: 'chat.systemEvent.callDuration.seconds',
      },
    },
    adaptiveCard: {
      bNearInvitation: {
        title: 'chat.adaptiveCard.bNearInvitation.title',
        description1: 'chat.adaptiveCard.bNearInvitation.description1',
        description2: 'chat.adaptiveCard.bNearInvitation.description2',
        imageAlt: 'chat.adaptiveCard.bNearInvitation.imageAlt',
        openApp: 'chat.adaptiveCard.bNearInvitation.openApp',
      },
    },
  },
  shared: {
    date: {
      today: 'shared.date.today',
      tomorrow: 'shared.date.tomorrow',
    },
    dialogs: {
      editScreenEmbed: {
        incorrectInputError: 'shared.dialogs.editScreenEmbed.incorrectInputError',
        notEmbeddableError: 'shared.dialogs.editScreenEmbed.notEmbeddableError',
      },
    },
  },
};

export const MAXIMUM_TOPIC_TABLE_COUNT = 3;

export const TOO_MANY_USERS_THRESHOLD = 30;

export const ERROR_MAILBOX_API_DISABLED = 'MailboxNotEnabledForRESTAPI';

export const TRIAL_EXPIRY_NOTICE_SUBTLE_REMAINING_DAYS = 14;
export const TRIAL_EXPIRY_NOTICE_WARNING_REMAINING_DAYS = 5;
export const BUY_LICENSE_URL = 'http://bnear.io/pricing';

export const DEFAULT_LOBBY_THEME = 'default';
